// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"MainContentMeuHotelPoliticas_sectionTitle__3cv8W","placeholderShimmer":"MainContentMeuHotelPoliticas_placeholderShimmer__2oInD"};